export const VOTING_TOOLS_DESIRED_OUTCOME_ALL = 0;
export const VOTING_TOOLS_DESIRED_OUTCOME_SHORT_SLATE = 1;
export const VOTING_TOOLS_DESIRED_OUTCOME_BOARD_CONTROL = 2;

export const VOTING_TOOLS_DDL_OPTION_SETTLEMENTS_ALL = 'Include Withdrawn, Settled';
export const VOTING_TOOLS_DDL_OPTION_SETTLEMENTS_ALL_VALUE = 0;
export const VOTING_TOOLS_DDL_OPTION_SETTLEMENTS_EXCLUDE_SETTLED = 'Exclude Settled';
export const VOTING_TOOLS_DDL_OPTION_SETTLEMENTS_EXCLUDE_SETTLED_VALUE = 1;
export const VOTING_TOOLS_DDL_OPTION_SETTLEMENTS_EXCLUDE_WITHDRAWN = 'Exclude Withdrawn';
export const VOTING_TOOLS_DDL_OPTION_SETTLEMENTS_EXCLUDE_WITHDRAWN_VALUE = 2;
export const VOTING_TOOLS_DDL_OPTION_SETTLEMENTS_EXCLUDE_WITHDRAWN_SETTLED = 'Exclude Withdrawn, Settled';
export const VOTING_TOOLS_DDL_OPTION_SETTLEMENTS_EXCLUDE_WITHDRAWN_SETTLED_VALUE = 3;

export const VOTING_TOOLS_DDL_OPTION_CARD_RECOMMENDATION_ALL = 'All';
export const VOTING_TOOLS_DDL_OPTION_CARD_RECOMMENDATION_ALL_VALUE = 0;
export const VOTING_TOOLS_DDL_OPTION_CARD_RECOMMENDATION_ALL_DISSIDENT = 'All Dissidents';
export const VOTING_TOOLS_DDL_OPTION_CARD_RECOMMENDATION_ALL_DISSIDENT_VALUE = 1;
export const VOTING_TOOLS_DDL_OPTION_CARD_RECOMMENDATION_SOME_DISSIDENTS = 'Some Dissidents';
export const VOTING_TOOLS_DDL_OPTION_CARD_RECOMMENDATION_SOME_DISSIDENTS_VALUE = 2;
export const VOTING_TOOLS_DDL_OPTION_CARD_RECOMMENDATION_MANAGEMENT = 'Management';
export const VOTING_TOOLS_DDL_OPTION_CARD_RECOMMENDATION_MANAGEMENT_VALUE = 3;

export const SUB_IS_TRIAL_NOT_FULL_TEXT = 'Data shown is limited for trialists.';
export const SUB_NOT_TRIAL_OR_FULL_TEXT =
  'Data is not available for your subscription. If you want more information on this data please contact your account manager.';

export default {
  VOTING_TOOLS_DESIRED_OUTCOME_ALL,
  VOTING_TOOLS_DESIRED_OUTCOME_SHORT_SLATE,
  VOTING_TOOLS_DESIRED_OUTCOME_BOARD_CONTROL,

  VOTING_TOOLS_DDL_OPTION_SETTLEMENTS_ALL,
  VOTING_TOOLS_DDL_OPTION_SETTLEMENTS_ALL_VALUE,
  VOTING_TOOLS_DDL_OPTION_SETTLEMENTS_EXCLUDE_SETTLED,
  VOTING_TOOLS_DDL_OPTION_SETTLEMENTS_EXCLUDE_SETTLED_VALUE,
  VOTING_TOOLS_DDL_OPTION_SETTLEMENTS_EXCLUDE_WITHDRAWN,
  VOTING_TOOLS_DDL_OPTION_SETTLEMENTS_EXCLUDE_WITHDRAWN_VALUE,
  VOTING_TOOLS_DDL_OPTION_SETTLEMENTS_EXCLUDE_WITHDRAWN_SETTLED,
  VOTING_TOOLS_DDL_OPTION_SETTLEMENTS_EXCLUDE_WITHDRAWN_SETTLED_VALUE,

  VOTING_TOOLS_DDL_OPTION_CARD_RECOMMENDATION_ALL,
  VOTING_TOOLS_DDL_OPTION_CARD_RECOMMENDATION_ALL_VALUE,
  VOTING_TOOLS_DDL_OPTION_CARD_RECOMMENDATION_ALL_DISSIDENT,
  VOTING_TOOLS_DDL_OPTION_CARD_RECOMMENDATION_ALL_DISSIDENT_VALUE,
  VOTING_TOOLS_DDL_OPTION_CARD_RECOMMENDATION_SOME_DISSIDENTS,
  VOTING_TOOLS_DDL_OPTION_CARD_RECOMMENDATION_SOME_DISSIDENTS_VALUE,
  VOTING_TOOLS_DDL_OPTION_CARD_RECOMMENDATION_MANAGEMENT,
  VOTING_TOOLS_DDL_OPTION_CARD_RECOMMENDATION_MANAGEMENT_VALUE,

  SUB_NOT_TRIAL_OR_FULL_TEXT,
  SUB_IS_TRIAL_NOT_FULL_TEXT
};
